<template>
    <div class="activities st-activity-list">
        <div v-for="item in items" :key="item.id" class="activity">
            <div class="activity-date">
                <div>{{ formatDate(item.date) }}</div>
                <div class="activity-time">{{ formatTime(item.date) }}</div>
            </div>
            <div class="activity-body">
                <slot name="item" :item="item">
                    <div v-if="item.title" class="activity-sender">{{ item.title }}</div>
                    <div v-if="item.author" :class="item.title ? 'activity-author' : 'activity-sender'">{{ item.author }}</div>
                    <div v-if="item.text" class="activity-message">{{ item.text }}</div>
                    <dl v-if="item.details && item.details.length" class="activity-details">
                        <div v-for="detail in item.details" :key="detail.label" class="activity-detail">
                            <dt>{{ detail.label }}</dt>
                            <dd>{{ detail.value }}</dd>
                        </div>
                    </dl>
                    <div v-if="item.note" class="activity-note">{{ item.note }}</div>
                </slot>
                <slot name="item-footer" :item="item"></slot>
            </div>
        </div>
        <div v-if="!items.length" class="activity-empty">
            <slot name="empty">{{ emptyText }}</slot>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

// The dated list of the Activități tab: date and time on the left, then who and what.
export default {
    name: 'StActivityList',
    props: {
        // { id, date, title, author, text, details: [{ label, value }], note }
        items: {
            type: Array,
            default: () => [],
        },
        dateFormat: {
            type: String,
            default: 'YYYY/MM/DD',
        },
        emptyText: {
            type: String,
            default: '',
        },
    },
    methods: {
        formatDate(date) {
            return moment(date).format(this.dateFormat);
        },
        formatTime(date) {
            return moment(date).format('HH:mm');
        },
    },
};
</script>

<style scoped lang="scss" src="@/assets/sass/pages/activities/activities.scss"></style>
<style scoped lang="scss">
.st-activity-list {
    .activity-author {
        margin-top: 0.25rem;
    }

    .activity-details {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 0.35rem 1.5rem;
        margin: 0.5rem 0 0;
    }

    .activity-detail {
        display: flex;
        gap: 0.4rem;
        min-width: 0;

        dt {
            flex: none;
            font-weight: 400;
            color: var(--gray);

            &::after {
                content: ':';
            }
        }

        dd {
            margin: 0;
            font-weight: 500;
            word-break: break-word;
        }
    }

    .activity-note {
        margin-top: 0.75rem;
        padding-left: 0.75rem;
        border-left: 3px solid var(--gray);
        white-space: pre-line;
        word-break: break-word;
    }

    .activity-empty {
        padding: 2rem 0;
    }

    @media (max-width: 575.98px) {
        .activity-details {
            grid-template-columns: minmax(0, 1fr);
        }
    }
}
</style>
